import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';

export const MANAGE_FOLLOWING_TABS = [
  'watchlist',
  'themes',
  'geographies',
] as const;

export type ManageFollowingTab = (typeof MANAGE_FOLLOWING_TABS)[number];

export const useManageFollowingDrawer = (activeDrawer: string) => {
  const { params, setQueryParams, deleteQueryParam } = useQueryParams();

  const isDrawerOpen = params[queryKeys.activeDrawer] === activeDrawer;

  const activeTab =
    (params[queryKeys.activeDrawerTab] as ManageFollowingTab) ??
    MANAGE_FOLLOWING_TABS[0];

  const openDrawer = (initialDrawerTab?: ManageFollowingTab) =>
    setQueryParams({
      [queryKeys.activeDrawer]: activeDrawer,
      ...(initialDrawerTab !== undefined
        ? { [queryKeys.activeDrawerTab]: initialDrawerTab }
        : {}),
    });

  const closeDrawer = () =>
    deleteQueryParam([queryKeys.activeDrawer, queryKeys.activeDrawerTab]);

  const setActiveTab = (tab: ManageFollowingTab) =>
    setQueryParams({ [queryKeys.activeDrawerTab]: tab });

  return {
    isDrawerOpen,
    openDrawer,
    closeDrawer,
    activeTab,
    setActiveTab,
  };
};
